'use client'

import React from 'react'

import { useSize } from '../../hooks'
import { Container } from './styles'

export interface CollapsibleProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Collapsible open state
   */
  open?: boolean

  /**
   * Collapsible children
   */
  children: React.ReactNode
}

/**
 * Collapsible component
 */
export const Collapsible = ({
  className,
  open,
  children,
}: CollapsibleProps) => {
  const contentRef = React.useRef<HTMLDivElement>(null)
  const { offsetHeight } = useSize(contentRef)
  const [height, setHeight] = React.useState<number | undefined>(0)

  React.useEffect(() => {
    setHeight(offsetHeight)
  }, [offsetHeight])

  return (
    <Container
      className={className}
      aria-hidden={!open}
      open={open}
      contentHeight={height}
    >
      <div ref={contentRef}>{children}</div>
    </Container>
  )
}
